export const updateWinSize = (sizeVal) => {
	return {
		type: "UPDATE_WIN_SIZE",
		size: sizeVal
	}
}
